import { Logo } from "@/components/brand/Logo";

const LOOP = ["Command", "Plan", "Create", "Approve", "Launch", "Measure", "Learn", "Recommend", "Grow"];

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[#050816] grid lg:grid-cols-[1.1fr_1fr]">
      <aside className="hidden lg:flex flex-col justify-between p-12 border-r border-[#243153] cq-grid-bg relative overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full opacity-[0.10] blur-3xl" style={{ background: "var(--cq-gradient)" }} />
        <div className="cq-label">AI Growth Command Centre</div>
        <div className="relative max-w-md">
          <img src={`${process.env.PUBLIC_URL || ""}/brand/cresqen-lockup.webp`} alt="CRESQEN — Command your growth" data-testid="auth-brand-lockup"
            className="w-full max-w-[420px] rounded-2xl border border-[#243153] shadow-[0_30px_80px_-30px_rgba(41,98,255,0.45)]" />
          <p className="mt-8 text-[#AAB6CC] text-sm leading-relaxed">
            Describe a business outcome. CRESQEN structures the objective, drafts the strategy and prepares every activity for your review. Nothing goes live without you.
          </p>
          <div className="mt-10 flex flex-wrap gap-2">
            {LOOP.map((s, i) => (
              <span key={s} className="font-mono text-[11px] text-[#7C8BAD] flex items-center gap-2">
                <span className={i === 3 ? "text-[#22E6F2]" : ""}>{s}</span>{i < LOOP.length - 1 && <span className="text-[#243153]">→</span>}
              </span>
            ))}
          </div>
        </div>
        <div className="font-mono text-[11px] text-[#5D6B8C]">cresqen.com · KRESS-ken</div>
      </aside>
      <main className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm cq-rise">
          <div className="lg:hidden mb-10"><Logo size={40} /></div>
          <h1 className="font-display text-3xl font-semibold text-[#F7FAFF]">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-[#AAB6CC]">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </main>
    </div>
  );
}
